module.exports = __webpack_public_path__ + "img/happy-at-sea-logo.199d990c.png";